
const DEFAULTS = {
    views: "PRIVATE", roles: ["IT_ADMIN", "ADMIN"], godKey: "GOD_MODE",
};

const toPerms = (perms) => {
    const arr = perms == null ? [] : Array.isArray(perms) ? perms : [perms];
    return [...new Set([DEFAULTS.godKey, ...arr.filter(Boolean)])];
};

const resolveUser = (u) => (u && typeof u === "object" && u.data && typeof u.data === "object") ? u.data : (u ?? {});

export const getUserAccess = (userOrAuth) => {
    const u = resolveUser(userOrAuth);
    const roles = Array.isArray(u.roles) && u.roles.length
        ? u.roles
        : (u.role ? [{ key: String(u.role).toUpperCase(), permissions: [] }] : []);
    const roleKeys = new Set(roles.map((r) => String(r?.key ?? r?.name ?? r ?? "").toUpperCase()).filter(Boolean));

    let permKeys;
    if (Array.isArray(u.permissions)) {
        permKeys = new Set(u.permissions.filter(Boolean));
    } else {
        permKeys = new Set();
        roles.forEach((r) => (r?.permissions ?? []).forEach((p) => p?.key && permKeys.add(p.key)));
    }

    const isGod = u.isRoot === true || permKeys.has(DEFAULTS.godKey) || roleKeys.has("IT_ADMIN");
    return { isGod, roleKeys, permKeys };
};

export const userHasAccess = (userOrAuth, item) => {
    const access = getUserAccess(userOrAuth);
    if (access.isGod) return true;
    const reqRoles = item?.roles ?? [];
    const reqPerms = (item?.permissions ?? []).filter((p) => p !== DEFAULTS.godKey);
    if (reqRoles.length === 0 && reqPerms.length === 0) return true;
    const roleOk = reqRoles.some((r) => access.roleKeys.has(r));
    const permOk = reqPerms.some((p) => access.permKeys.has(p));
    return roleOk || permOk;
};

export const createBuilder = (DATA_USER_AUTH = null) => {

 
    const route = ({ uri, path, component = null, label = "", perms, roles = DEFAULTS.roles, sidebar = true, icon = null }) => ({
        views: DEFAULTS.views, path: path ?? `/${uri}`,
        component, roles, permissions: toPerms(perms),
        label, icon, displayInHeader: false,
        displayInFooter: false, displayInSidebar: sidebar,
    });

    const group = ({ label, children = [], perms, roles = DEFAULTS.roles, icon = null, sidebar = true }) => ({
        views: DEFAULTS.views, path: ``,
        component: null, roles, permissions: toPerms(perms),
        label, icon, displayInHeader: false, displayInFooter: false,
        displayInSidebar: sidebar, subItems: children.filter(Boolean),
    });

    const crud = ({ label, listIcon = null, roles = DEFAULTS.roles, list, create, edit, extras = [], groupPerms }) => {
        const items = [];

        if (list) {
            items.push(route({
                uri: list.uri, component: list.component,
                label: list.label ?? "Listado", perms: list.perm, roles,
                icon: list.icon ?? listIcon, sidebar: list.sidebar ?? true,
            }));
        }
        if (create) {
            items.push(route({
                uri: create.uri, component: create.component,
                label: create.label ?? "", perms: create.perm, roles, sidebar: false,
            }));
        }
        if (edit) {
            items.push(route({
                uri: edit.uri, component: edit.component,
                label: edit.label ?? "", perms: edit.perm, roles, sidebar: false,
            }));
        }
        extras.forEach((e) => e && items.push(e));

        return group({
            label, icon: listIcon, roles,
            perms: groupPerms ?? list?.perm,
            children: items,
        });
    };

    const userAccess = getUserAccess(DATA_USER_AUTH);

    const canSee = (item) => userHasAccess(DATA_USER_AUTH, item);

    const access = (tree = []) =>
        tree.map((item) => {
            if (item?.subItems) {
                const kids = access(item.subItems);
                if (kids.length === 0) return null;
                return { ...item, subItems: kids };
            }
            return canSee(item) ? item : null;
        }).filter(Boolean);

    return {   route, group, crud, access, userAccess };
};